import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_SERVER_URL: z.url(),
    /** the public site's own address: canonical links, link previews, sitemap.xml */
    VITE_SITE_URL: z.url().default("https://tabankhodro.com"),
  },
  // SAFETY: Vite injects import.meta.env at build time; untyped in this package
  runtimeEnv: (import.meta as any).env,
  emptyStringAsUndefined: true,
});
